<template>
  <div class="confirmation-view">
    <div class="paid-container">
      <div class="checkmark-container">
        <img :src="checkmark" />
      </div>
      <div class="paid-content__1">
        <span> Order Confirmed! </span>
      </div>
      <div class="paid-content__2">
        <span>
          Head over to discord and follow the instructions to activate your
          account. Please allow up to 24 hours for your order to register in our
          system.
        </span>
      </div>
      <div class="paid-content__3">
        <span>Discord invite: </span>
        <a href="https://discord.gg/aUNMrjg" class="link__2">Click HERE</a>
      </div>
    </div>
  </div>
</template>

<script>
import checkmark from "../assets/images/checkmark.svg";
import { useGtm } from "@gtm-support/vue2-gtm";

export default {
  name: "Confirmation",
  metaInfo: {
    title: "Market Moves - Confirmation",
    titleTemplate: "Confirmation",
  },
  setup() {
    const gtm = useGtm();

    function triggerEvent() {
      gtm.trackEvent({
        event: "event name",
        category: "category",
        action: "click",
        label: "My custom component trigger",
        value: 5000,
        noninteraction: false,
      });
    }

    return {
      triggerEvent,
    };
  },
  data() {
    return {
      checkmark,
    };
  },
  mounted() {
    this.$gtm.trackView("Confirmation", "/confirmation");
    this.$gtm.enable(true);

    if (this.$gtm.enabled()) {
      window.dataLayer?.push({ ecommerce: null });
      window.dataLayer?.push({
        ecommerce: {
          purchase: {
            actionField: {
              id: "T12345", // Transaction ID. Required for purchases and refunds.
              affiliation: "Online Store",
              revenue: "35.43", // Total transaction value (incl. tax and shipping)
              tax: "4.90",
              shipping: "5.99",
              coupon: "SUMMER_SALE",
            },
            products: [
              {
                // List of productFieldObjects.
                name: "Triblend Android T-Shirt", // Name or ID is required.
                id: "12345",
                price: "15.25",
                brand: "Google",
                category: "Apparel",
                variant: "Gray",
                quantity: 1,
                coupon: "", // Optional fields may be omitted or set to empty string.
              },
              {
                name: "Donut Friday Scented T-Shirt",
                id: "67890",
                price: "33.75",
                brand: "Google",
                category: "Apparel",
                variant: "Black",
                quantity: 1,
              },
            ],
          },
        },
      });
    }
  },
};
</script>

<style scoped>
.confirmation-view {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  justify-content: center;
  align-items: center;
  height: 300px;
  width: 400px;
  background-color: #36393f;
  color: #f8f8f8;
  font-size: 14px;
  border-radius: 8px;
  margin: 0 auto;
  box-shadow: 1px 1px 0px #282b2f, 2px 2px 0px #2f3033, 3px 3px 0px #282b2f,
    4px 4px 0px #2f3033, 5px 5px 0px #282b2f, 6px 6px 0px #2f3033;
}

.paid-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.checkmark-container {
  height: 80px;
  width: 80px;
}

.checkmark-container img {
  height: 100%;
  width: 100%;
}

.paid-content__1 {
  padding: 10px 0 0 0;
}

.paid-content__2 {
  padding: 10px 40px 0 40px;
}

.paid-content__3 {
  padding: 20px 40px 0 40px;
}

.paid-content__4 {
  padding: 5px 40px 0 40px;
}

.link__1 {
  color: #23be7b;
  text-decoration: none;
}

.link__2 {
  color: #7289da;
  text-decoration: none;
}
</style>